export default function SectionTitle({ title }) {
  return (
    <h2 style={{ margin: "30px 0", color: "#4f46e5" }}>
      {title}
    </h2>
  );
}
